import { styled } from '@mui/material/styles'

export const Aside = styled('aside')`
    position: fixed;
    top: 0;
    left: 0;
    width: 220px;
    height: 100vh;
    border-right: 1px solid #E8F0FF;
    padding: 16px 8px;
    display: flex;
    background: #F3F4F6;
    color: #2B2B2B;
    z-index: 1000;

    // На телефоне и планшете это экран «Главная» на весь экран: открывается
    // вкладкой внизу (layout/mobile-bars.js), а не выезжает сбоку
    @media (max-width: 899px) {
      top: 0;
      bottom: 0;
      width: 100%;
      height: auto;
      border-right: none;
      z-index: 1200;
      background: #F5F7F9;
      // Снизу оставляем место под вкладки, сверху - под вырез экрана
      padding: calc(12px + env(safe-area-inset-top, 0px)) 16px calc(70px + env(safe-area-inset-bottom, 0px));
      visibility: hidden;
      opacity: 0;
      transform: translateY(8px);
      transition: opacity 0.15s ease, transform 0.15s ease, visibility 0.15s;

      &.open {
        visibility: visible;
        opacity: 1;
        transform: none;
      }
    }
`

export const AsideContent = styled('div')`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto
`;

export const UserMenuItem = styled('div')`
  font-weight: 450;
  font-size: 14px;
  line-height: 24px;
  cursor: pointer;
  padding: 8px;
  margin: 0 -8px;
  color: ${props => props.color || '#272E35'};
  display: flex;
  align-items: center;

  & svg {
    margin-right: 15px;
  }
`

export const AsideHeader = styled('header')`
  padding: 0px 4px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;

  // На экране «Главная» сначала человек и парк, потом разделы: логотип уже
  // есть в нижней вкладке и в шапке входа, место под ним нужнее
  @media (max-width: 899px) {
    display: none;
  }
`

export const MainUl = styled('ul')`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #4A545E;
  padding-left: 5px;

  // Названия разделов не переносим: перенос съедает высоту, и нижние
  // разделы вместе с настройками уходят за край экрана
  white-space: nowrap;

  & > li {
    cursor: pointer;
    padding: 2px 0;

    // Раздел со вложенным списком - такая же строка, как обычный раздел:
    // те же отступы, та же подсветка. Раньше у него не было ни внутреннего
    // padding, ни hover, поэтому он был на 12px ниже соседей, текст уезжал
    // правее на 9px, а наведение не подсвечивало ничего
    & a,
    & > div > button {
      border-radius: 8px;
      padding: 8px 12px;
      width: 100%;
      display: flex;
      align-items: center;
      gap: 0;

      &:hover {
        color: #1D4ED8;
        background: #E8F0FF;
      }

      &.active {
        color: #1D4ED8;
        background: #E8F0FF;
      }
    }
  }

  // Иконки в наборе разного размера (16, 18 и 20 точек по ширине), и из-за
  // этого названия разделов начинались в трёх разных местах. Ширину слота
  // фиксируем, высоту оставляем авто - viewBox сохраняет пропорции, ничего
  // не растягивается
  & svg {
    flex: 0 0 20px;
    height: auto;
    margin-right: 12px;
  }

  // Экран «Главная»: крупные строки-карточки, которые удобно попадать
  // пальцем, и подпись «Есть новое» вместо красной точки - точка в углу
  // строки на телефоне терялась
  @media (max-width: 899px) {
    font-size: 16px;
    padding-left: 0;
    margin: 12px 0 0;

    & > li {
      padding: 3px 0;

      & a,
      & > div > button {
        min-height: 52px;
        padding: 12px 14px;
        background: #FFFFFF;
        border: 1px solid #E9ECEF;
        border-radius: 12px;
      }

      & a.active,
      & > div > button.active {
        border-color: #BFD3FF;
      }
    }

    & svg {
      flex: 0 0 24px;
      margin-right: 14px;
    }

    // красная точка - только для широкого экрана
    & .attention-dot {
      display: none;
    }

    & .attention + span {
      margin-left: 8px;
    }
  }
`

export const SubUl = styled('ul')`
  // Отрицательный отступ компенсировал padding у строки раздела. Строку
  // с тех пор выровняли по остальным, и этот минус начал выталкивать
  // подпункты за левый край экрана
  margin: 0;
  padding-top: 4px;

  & > li {
    cursor: pointer;
    display: flex;
    margin-bottom: 4px;

    & a {
      border-radius: 8px;
      // 45 точек - ровно под названием раздела: иконка плюс отступ
      padding: 8px 12px 8px 44px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      &:hover {
        color: #1D4ED8;
        background: #E8F0FF;
      }

      &.active {
        background: #E8F0FF;

        & .badge {
          border-color: #2B2B2B;
          background: #2B2B2B;
          color: #1D4ED8;
        }
      }

      @media (max-width: 899px) {
        min-height: 44px;
        font-size: 15px;
        padding-left: 52px;
      }
    }

  }
`

// Подпись «Есть новое» у раздела на экране «Главная». На широком экране
// остаётся красная точка, подпись там не нужна
export const ItemAttention = styled('span')`
  display: none;

  @media (max-width: 899px) {
    display: inline-flex;
    align-items: center;
    margin-left: auto;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
    color: #1D4ED8;
    background: #E8F0FF;
  }
`

export const UserBlockWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  margin-top: auto;
  align-items: center;
`

export const UserWrapper = styled('div')`
  display: flex;
  width: 100%;
  cursor: pointer;
  align-items: center;
  padding: 8px;
`

export const UserAvatar = styled('div')`
  flex-shrink: 0;
  border-radius: 50%;
  height: 32px;
  color: #05205E;
  width: 32px;
  margin-right: 10px;
  background: #D7E4FF;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  font-size: 12px;
  font-weight: 600;

  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  text-transform: uppercase;
`

export const UserInfo = styled('div')`
  min-width: 0;
`

export const UserTitle = styled('div')`
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  color: #272E35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
export const UserSubTitle = styled('div')`
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  color: #555F6D;
`

export const CopyButton = styled('button')`
      margin-top: 5px;
      cursor: pointer;
      display: flex;
      align-items: center;
      text-align: left;
      background: #E8F0FF;
      padding: 7px 9px;
      border: 1px solid rgb(207, 214, 221);
      border-radius: 6px;
      color: #2B2B2B;
      gap: 12px;
      
      &:hover {
        color: #1D4ED8;
        background: #E8F0FF;
      }
`

export const SidebarButton = styled('button')`
      width: 100%;
      margin-top: 5px;
      cursor: pointer;
      align-items: center;
      background: unset;
      padding: 11px 9px;
      border: 1px solid rgb(207, 214, 221);
      border-radius: 6px;
      color: #2B2B2B;
      gap: 12px;
      
      &:hover {
        color: #1D4ED8;
        background: #E8F0FF;
        border: 1px solid rgb(207, 214, 221);
      }
`

export const CompanyWrapper = styled('div')`
  color: #2b2b2b;
  padding-left: 4px;
  margin-bottom: 4px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

// Строка раздела, у которого есть вложенный список. Это кнопка, а не
// ссылка: она раскрывает список и уводит на первый пункт, а не ведёт по
// фиксированному адресу. Оформление приходит из MainUl - здесь только
// сброс кнопочных умолчаний
export const ParentRow = styled('button')`
  position: relative;
  appearance: none;
  border: none;
  background: transparent;
  font: inherit;
  color: inherit;
  text-align: left;
  cursor: pointer;
`

export const Chevron = styled('span')`
  margin-left: auto;
  padding-left: 8px;
  display: inline-flex;
  align-items: center;
  user-select: none;

  && svg {
    width: 16px;
    height: 16px;
    flex: 0 0 16px;
    margin: 0;
    color: #555F6D;
    opacity: 1;
    transition: transform 0.15s;
  }

  &&.open svg {
    transform: rotate(180deg);
  }
`

// Выбор компании. Вариант `outlined` у нашего Select построен на InputBase,
// а у него рамки нет вовсе - поле выглядело просто текстом, и что по нему
// можно щёлкнуть, было неочевидно
export const CompanySelectBox = styled('div')`
  border: 1px solid #CFD6DD;
  border-radius: 6px;
  padding: 6px 12px;
  background: #fff;
  font-weight: 600;

  &:focus-within {
    border-color: #6792F4;
  }

  & .MuiSelect-select {
    font-weight: 600;
    font-size: 14px;
  }
`

// Блок человека. На широком экране прижат к низу меню, на «Главной» телефона
// стоит первым: кто я, в каком парке и что мне нужно
export const AsideUser = styled('div')`
  margin-top: auto;

  // На телефоне человек - аватарка в верхней панели на каждой странице
  // (layout/mobile-avatar.js), поэтому здесь блок не нужен
  @media (max-width: 899px) {
    display: none;
  }
`
